module.exports = __webpack_public_path__ + "static/img/liuliucart.963e5a4d.jpg";